import { useState, useEffect, useRef } from "react";
import { string } from "prop-types";

import { PopupModal } from "react-calendly";

const propTypes = {
  title: string,
  description: string,
  linkText: string.isRequired,
  url: string.isRequired,
};

const ExecEdCalendlyLinkBox = (props) => {
  const { title, description, linkText, url } = props;

  const [isOpen, setIsOpen] = useState(false);

  // See if body has the .is-page-editor class;
  // this means we're in the EE (Eperience Editor) in Sitecore,
  // and need to disable the Calendly popup.
  const isPageEditor = document.body.classList.contains("is-page-editor");

  // Calendly modal does not support closing with ESC key;
  // adding this functionality manually.
  useEffect(() => {
    if (isOpen) {
      // Prevent scrolling on the body when modal is open
      document.body.style.overflow = "hidden";
      // console.log(document.querySelector(".calendly-popup-content > button"));
      // const testing = document.querySelectorAll(
      //   ".calendly-popup-content button",
      // );
      // console.log(testing);
      // document.querySelector(".calendly-popup-content").focus();
    } else {
      document.body.style.overflow = "unset";
    }

    // document.addEventListener("keydown", (e) => {
    //   console.log("e:", e);
    //   if (e.key === "Escape") {
    //     console.log("esc pressed");
    //     setIsOpen(false);
    //   }
    // });
  }, [isOpen]);

  return (
    <>
      <section className="calendly side-bar">
        {title && (
          <div className="side-bar__title calendly__title">{title}</div>
        )}

        <button
          className="calendly__button"
          onClick={() => {
            !isPageEditor && setIsOpen(true);
          }}
        >
          <span>{linkText}</span>
        </button>

        {description && <p>{description}</p>}
      </section>

      <PopupModal
        url={url}
        onModalClose={() => setIsOpen(false)}
        open={isOpen}
        /*
         * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
         * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
         */
        rootElement={document.body}
      />
    </>
  );
};

ExecEdCalendlyLinkBox.propTypes = propTypes;
export default ExecEdCalendlyLinkBox;

const arrowRightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-arrow-right"
  >
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);
